interface Trainers{
    name: string,
    photo: string,
    info: string,
    instagram: string
}

const trainers: Trainers[] = [
    {
        name: 'Vlad',
        photo: '../../assets/trainer.webp',
        info: 'trainer',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Vlad',
        photo: '../../assets/trainer.webp',
        info: 'trainer',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Vlad',
        photo: '../../assets/trainer.webp',
        info: 'trainer',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Vlad',
        photo: '../../assets/trainer.webp',
        info: 'trainer',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Vlad',
        photo: '../../assets/trainer.webp',
        info: 'trainer',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
    {
        name: 'Danya',
        photo: '../../assets/trainer.webp',
        info: 'trainer2',
        instagram: 'https://instagram.com/prmakkk'
    },
]

export default trainers;